import { render } from "./CreateOrderPage.vue?vue&type=template&id=43d884c9&scoped=true&ts=true"
import script from "./CreateOrderPage.vue?vue&type=script&lang=ts"
export * from "./CreateOrderPage.vue?vue&type=script&lang=ts"

import "./CreateOrderPage.vue?vue&type=style&index=0&id=43d884c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d884c9"]])

export default __exports__